import { APP_CLIENT_ID } from '../config/cognito-config';
import { LocalStorageController } from '../util/local-storage-controller';

/**
 * Utility method to get get a given Cognito JWT Token out of
 * local storage and decode it
 */
const getJwtTokenFromLocalStorage = (key: string) => {
  const fullJwtToken = LocalStorageController.getItem(key);
  if (!fullJwtToken) return null;
  const jwtPayload = fullJwtToken.split('.')[1];
  const decodedJwtToken = JSON.parse(atob(jwtPayload));
  return {
    decodedJwtToken,
    fullJwtToken,
  };
};

/**
 * This method is mostly lifted from the Cognito Auth library, which
 * is how they get their tokens out of local storage and check them
 */
export const getLegacyTokens = () => {
  const decodedJwtTokens: any = {
    accessToken: null,
    idToken: null,
  };
  const jwtTokens: any = {
    accessToken: null,
    idToken: null,
  };

  const lastUserKey = `CognitoIdentityServiceProvider.${APP_CLIENT_ID}.LastAuthUser`;
  const lastUserName = LocalStorageController.getItem(lastUserKey);
  const keyPrefix = `CognitoIdentityServiceProvider.${APP_CLIENT_ID}.${lastUserName}`;
  const idTokenKey = `${keyPrefix}.idToken`;
  const accessTokenKey = `${keyPrefix}.accessToken`;
  if (lastUserName) {
    // Try to do this, but if it fails, just make the user sign in
    try {
      const accessTokenResult = getJwtTokenFromLocalStorage(accessTokenKey);
      const idTokenResult = getJwtTokenFromLocalStorage(idTokenKey);
      decodedJwtTokens.accessToken = accessTokenResult?.decodedJwtToken;
      jwtTokens.accessToken = accessTokenResult?.fullJwtToken;
      decodedJwtTokens.idToken = idTokenResult?.decodedJwtToken;
      jwtTokens.idToken = idTokenResult?.fullJwtToken;
    } catch (err) {
      decodedJwtTokens.accessToken = null;
      decodedJwtTokens.idToken = null;
      jwtTokens.accessToken = null;
      jwtTokens.idToken = null;
    }
  }

  const now = Math.floor(new Date().valueOf() / 1000);
  let hasValidAccessToken = false;
  let hasValidIdToken = false;
  if (decodedJwtTokens.accessToken != null) {
    hasValidAccessToken = now < decodedJwtTokens.accessToken?.exp;
  }
  if (decodedJwtTokens.accessToken != null) {
    hasValidIdToken = now < decodedJwtTokens.idToken?.exp;
  }

  if (hasValidAccessToken && hasValidIdToken) {
    return jwtTokens;
  }

  if (lastUserName) {
    LocalStorageController.removeItem(lastUserKey);
    LocalStorageController.removeItem(idTokenKey);
    LocalStorageController.removeItem(accessTokenKey);
  }

  return null;
};

export const clearLegacyTokens = () => {
  const tokens = getLegacyTokens();
  if (tokens) {
    const lastUserKey = `CognitoIdentityServiceProvider.${APP_CLIENT_ID}.LastAuthUser`;
    const lastUserName = LocalStorageController.getItem(lastUserKey);
    if (lastUserName) {
      const keyPrefix = `CognitoIdentityServiceProvider.${APP_CLIENT_ID}.${lastUserName}`;
      const idTokenKey = `${keyPrefix}.idToken`;
      const accessTokenKey = `${keyPrefix}.accessToken`;

      LocalStorageController.removeItem(lastUserKey);
      LocalStorageController.removeItem(idTokenKey);
      LocalStorageController.removeItem(accessTokenKey);
    }
  }
};
